import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {LocalStoreService, StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";
import {Lib} from "../../../../../libs/Lib";

/** Title/Table font defaults — kept in sync with block-constants. Duplicated here
 *  to avoid a circular import (block-constants registers BlockBeaconStyleComponent). */
const TITLE_FONT_DEFAULT = {
    fontSize: '36', fontColor: '16777215', fontFamily: 'Arial',
    fontWeight: 'bold', fontStyle: 'normal', textDecoration: 'none',
    textAlign: 'left', alignSelf: 'center', autoScaling: '1', wrap: '0'
};
const TABLE_FONT_DEFAULT = {
    fontSize: '22', fontColor: '16777215', fontFamily: 'Arial',
    fontWeight: 'normal', fontStyle: 'normal', textDecoration: 'none',
    textAlign: 'left', alignSelf: 'center', autoScaling: '1', wrap: '0'
};

@Component({
    selector: 'app-scene-block-beacon-style',
    templateUrl: './block-beacon-style.component.html',
    styleUrls: ['./block-beacon-style.component.scss'],
    standalone: false
})
export class BlockBeaconStyleComponent extends BlockBaseComponent {

    /** Read-only mirror of the Beacon block's top-level mode — drives toggle visibility. */
    mode: 'all' | 'inventory' = 'all';

    showTitle: boolean = true;
    showFound: boolean = true;
    showMissing: boolean = true;
    showTotal: boolean = true;
    showRssi: boolean = true;
    showClosest: boolean = true;
    showClosestRssi: boolean = true;
    showLastSeen: boolean = true;
    columns: number = 1;
    columnOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    displayMode: string = 'default';
    displayModeOptions = [
        {value: 'default', label: 'Table', icon: 'list_alt'},
        {value: 'tile',    label: 'Tile',  icon: 'dashboard'}
    ];
    separatorColorHex: string = '#FFFFFF';
    titleFontConfig: any = null;
    tableFontConfig: any = null;

    constructor(
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        protected override localStoreService: LocalStoreService
    ) {
        super(storeSelector, dialog, localStoreService);
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.loadFromStore();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [];
    }

    loadFromStore() {
        const beacon = this.sceneItem?.Data?.[0]?.Beacon?.[0];
        if (!beacon) return;

        // Migrate older Beacon blocks that predate the Title/Table split: dispatch the
        // missing slices so the font selectors bind to real store objects.
        if (!beacon.Title || !beacon.Table) {
            const migrations: any[] = [];
            if (!beacon.Title) migrations.push({
                key: 'Title',
                value: [{Font: [{$: {...TITLE_FONT_DEFAULT}}]}],
                storePath: 'Data[0].Beacon[0]'
            });
            if (!beacon.Table) migrations.push({
                key: 'Table',
                value: [{Font: [{$: {...TABLE_FONT_DEFAULT}}]}],
                storePath: 'Data[0].Beacon[0]'
            });
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId, sceneItemId: this.sceneItem.$.id, values: migrations
            });
            return;
        }

        if (beacon.$) {
            const props = beacon.$;
            this.mode = (props.mode === 'inventory') ? 'inventory' : 'all';
            this.showTitle = props.showTitle !== '0';
            this.showFound = props.showFound !== '0';
            this.showMissing = props.showMissing !== '0';
            this.showTotal = props.showTotal !== '0';
            this.showRssi = props.showRssi !== '0';
            this.showClosest = props.showClosest !== '0';
            this.showClosestRssi = props.showClosestRssi !== '0';
            this.showLastSeen = props.showLastSeen !== '0';
            this.columns = Math.max(1, Math.min(10, Number(props.columns) || 1));
            const sep = props.separatorColor;
            this.separatorColorHex = (sep != null && sep !== '')
                ? Lib.DecimalToHex(sep) : '#FFFFFF';
            this.displayMode = props.displayMode === 'tile' ? 'tile' : 'default';
        }
        this.titleFontConfig = beacon.Title[0];
        this.tableFontConfig = beacon.Table[0];
    }

    saveToStore() {
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [
                {key: 'showTitle',         value: this.showTitle ? '1' : '0',                          storePath: 'Data[0].Beacon[0].$'},
                {key: 'showFound',         value: this.showFound ? '1' : '0',                          storePath: 'Data[0].Beacon[0].$'},
                {key: 'showMissing',       value: this.showMissing ? '1' : '0',                        storePath: 'Data[0].Beacon[0].$'},
                {key: 'showTotal',         value: this.showTotal ? '1' : '0',                          storePath: 'Data[0].Beacon[0].$'},
                {key: 'showRssi',          value: this.showRssi ? '1' : '0',                           storePath: 'Data[0].Beacon[0].$'},
                {key: 'showClosest',       value: this.showClosest ? '1' : '0',                        storePath: 'Data[0].Beacon[0].$'},
                {key: 'showClosestRssi',   value: this.showClosestRssi ? '1' : '0',                    storePath: 'Data[0].Beacon[0].$'},
                {key: 'showLastSeen',      value: this.showLastSeen ? '1' : '0',                       storePath: 'Data[0].Beacon[0].$'},
                {key: 'columns',           value: String(this.columns || 1),                          storePath: 'Data[0].Beacon[0].$'},
                {key: 'separatorColor',    value: String(Lib.HexToDecimal(this.separatorColorHex)),   storePath: 'Data[0].Beacon[0].$'},
                {key: 'displayMode',       value: this.displayMode,                                    storePath: 'Data[0].Beacon[0].$'},
            ]
        });
    }
}
